import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { API_URL } from "../../Config/api";

const Employee = ({ value }) => {
  const accessToken = localStorage.getItem("token");
  const [empRole, setEmpRole] = useState([]);

  useEffect(() => {
    const getEmpRole = async () => {
      if (value) {
        try {
          const res = await fetch(`${API_URL}/hr/employee_roles/${value}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          });
          const data = await res.json();
          console.log("Employee Role Count.........", data);

          // 🔥 SAFETY CHECK: Ensure we default to an empty array if data.message is missing
          setEmpRole(Array.isArray(data.message) ? data.message : []);
        } catch (error) {
          console.error("Error fetching Employee Role Count:", error);
          setEmpRole([]); // Keep it an array on failure
        }
      }
    };
    getEmpRole();
  }, [value, accessToken]);

  // 🔥 SAFETY CHECK: Double-check empRole is an array before filtering
  const safeEmpRole = Array.isArray(empRole) ? empRole : [];
  const filteredData = safeEmpRole.filter(
    (entry) => entry.service_title !== null && entry.professional_count !== 0,
  );

  const labels = filteredData.map((entry) => entry.service_title);
  const values = filteredData.map((entry) => entry.professional_count);

  return (
    <Box
      sx={{ flexGrow: 1, width: "100%", height: "100%" }}
      style={{
        background: "#ffffff",
        boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
        borderRadius: "10px",
      }}
    >
      <Typography
        align="left"
        sx={{ fontSize: 16, fontWeight: 600, pl: "10px", pt: "8px" }}
        color="text.secondary"
        gutterBottom
      >
        EMPLOYEE ROLES
      </Typography>
      <Grid item xs={12} container spacing={1}>
        <Grid item lg={12} md={12} xs={12}>
          {/* By passing labels and values directly, we avoid the infinite loop issue! */}
          <Chart
            options={{
              chart: {
                type: "pie",
              },
              labels: labels,
              legend: {
                show: true,
                position: "bottom",
              },
              dataLabels: {
                enabled: false,
              },
            }}
            series={values}
            type="pie"
            height="360"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Employee;
